import medal from '../../../assets/images/about/honor/medal.png'
import dot from '../../../assets/images/about/honor/dot.png'
import radiusTop from '../../../assets/images/about/path/timeline-up.png'
import radiusDown from '../../../assets/images/about/path/timeline-down.png'

import styles from './style.module.scss'

const honorList = [
    {
        index: 1,
        title: '获得众多科技型奖项',
        list: [
            { index: 1, content: '国家科学技术进步二等奖', },
            { index: 2, content: '湖南省科学创新奖', },
            { index: 3, content: '公安部科学技术二等奖', },
            { index: 4, content: '江苏省公安厅科技强警一等奖', },
            { index: 5, content: '江苏省科学技术一等奖', },
            { index: 6, content: '2022数字政府创新成果与实践一等奖', },
            { index: 7, content: '广东省科学技术二等奖', },
            { index: 8, content: '首届中国国际进口博览会网络安保突出贡献奖' },
            { index: 9, content: '上海市科学技术进步二等奖', },
            { index: 10, content: '……', },
            { index: 11, content: '四川省科学技术进步二等奖', },
        ]
    },
    {
        index: 2,
        title: '获得众多专业级认证',
        list: [
            { index: 1, content: 'ISO20000信息技术服务管理体系认证证书', },
            { index: 2, content: '通过国际研发能力成熟度CMMI5认证', },
            { index: 3, content: 'ISO27001信息安全管理体系认证证书', },
            { index: 4, content: '国家高技术研究发展计划成果产业化基地', },
            { index: 5, content: 'ISO14001环境管理体系认证证书', },
            { index: 6, content: '……', },
            { index: 7, content: 'ISO9001质量管理体系认证证书' },
        ]
    }
];

const Honor = () => {
    return (
        <div className={styles['honor-wrapper']}>
            <div className={styles['honor-container']}>
                <img src={medal} alt="" />
                <div className={styles['honor-top']}>
                    <img src={radiusTop} alt="" />
                </div>
                {honorList.map((item) => (
                    <div className={styles['honor-item']} key={item.index}>
                        <div className={styles['title']}>{item.title}</div>
                        <div className={styles['radius']}>
                            <img src={dot} alt="" />
                        </div>
                        <div className={styles['honor-content']}>
                            {item.list.map((honor) => (
                                <p key={honor.index}>{honor.content}</p>
                            ))}
                        </div>
                    </div>
                ))}
                <div className={styles['honor-bottom']}>
                    <img src={radiusDown} alt="" />
                </div>
            </div>
        </div>
    )
}
export default Honor